module.exports = __webpack_public_path__ + "media/images/sp/plans/search_form/location_type_both_location@3x-f1186e79cb1f04d39a9839cfeb83b435.webp";